/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_WikiInputs */

const en_mk_preview_wiki = /** @type {(inputs: Mk_Preview_WikiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiki`)
};

const id_mk_preview_wiki = /** @type {(inputs: Mk_Preview_WikiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiki`)
};

/**
* | output |
* | --- |
* | "Wiki" |
*
* @param {Mk_Preview_WikiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_wiki = /** @type {((inputs?: Mk_Preview_WikiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_WikiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_wiki(inputs)
	return en_mk_preview_wiki(inputs)
});